import { render } from "./PartyBanner.vue?vue&type=template&id=227d76c6&scoped=true"
import script from "./PartyBanner.vue?vue&type=script&lang=js"
export * from "./PartyBanner.vue?vue&type=script&lang=js"

import "./PartyBanner.vue?vue&type=style&index=0&id=227d76c6&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227d76c6"]])

export default __exports__